import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

// Accès à l'espace administration pour un compte (COOPER'S, expert…) doté d'un rôle personnalisé.
export const EspaceAdministrationButton = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user?.custom_role_admin_access || ['admin', 'super_admin'].includes(user.role) || pathname.startsWith('/admin')) {
    return null;
  }
  return (
    <Link
      to="/admin/dashboard"
      data-testid="espace-administration-btn"
      className="fixed bottom-5 left-5 z-50 inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white shadow-lg transition-transform hover:-translate-y-0.5"
    >
      <ShieldCheck className="h-4 w-4" />
      Espace administration · {user.custom_role_label}
    </Link>
  );
};
